<template>
  <resource-list-layout :resourceTitle="title">
    <template v-slot:filter>
      <ticket-manage-filter :fitter="searchObj" :admin-users="adminUsers" @search="handleSearch"></ticket-manage-filter>
    </template>
    <resource-list-page-content :pageData="pageData" :cols="cols" :show-action-column="true" v-loading="loading">
      <template v-slot:action="{ scope }">
        <el-popconfirm
          v-if="scope.row.sign_status !== '已撤销'"
          confirmButtonText="确定"
          cancelButtonText="取消"
          title="是否确定撤销？"
          @onConfirm="handleRevoke(scope.$index, scope.row.sign_status)"
        >
          <template v-slot:reference>
            <el-button type="text" size="medium">撤销</el-button>
          </template>
        </el-popconfirm>
      </template>
    </resource-list-page-content>
  </resource-list-layout>
</template>
<script>
import ResourceListLayout from 'common/ResourceListLayout'
import ResourceListPageContent from 'common/ResourceListPageContent'
import TicketManageFilter from './TicketManageFilter'
import { combineStr } from '../../lib/resourcePageUtils.js'
export default {
  name: 'TicketManagePage',
  components: {
    ResourceListLayout,
    ResourceListPageContent,
    TicketManageFilter
  },
  computed: {
    searchStr: function () {
      return combineStr(this.searchObj)
    }
  },
  watch: {
    'pageOption.currentPage': {
      handler (newVal) {
        this.fetchData()
      }
    },
    'pageOption.pageSize': {
      handler (newVal) {
        this.fetchData()
      }
    }
  },
  data () {
    return {
      title: '到票管理',
      pageData: [],
      cols: [
        { label: '编号', prop: 'id' },
        { label: '发票号', prop: 'ticket_num', width: 180 },
        { label: '发票代码', prop: 'ticket_code', width: 120 },
        { label: '发票校验码', prop: 'ticket_verification_code', width: 200 },
        { label: '发票类型', prop: 'ticket_type', width: 200 },
        { label: '公司名称', prop: 'company_name' },
        { label: '项目', prop: 'item_name' },
        { label: '合计金额(不含税)', prop: 'amount_total', width: 130 },
        { label: '开票时间', prop: 'ticket_at', width: 100 },
        { label: '签收状态', prop: 'sign_status' },
        { label: '操作人', prop: 'operator.username' },
        { label: '操作时间', prop: 'created_at', width: 170 }
      ],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        searchCurrentPage: 1,
        pageSize: 30 // 每页显示条数
      },
      searchObj: {
        ticket_num: '',
        company_id: '',
        ticket_type: '',
        sign_status: '',
        created_at: '',
        ticket_at: '',
        operator_id: ''
      },
      searchLoading: false,
      searchCompanies: [],
      ticketNumChange: false,
      loading: false,
      adminUsers: [],
      searchVisible: false,
      timeoutId: null
    }
  },
  methods: {
    fetchData () {
      this.loading = true
      this.$axios.get("/api/admin/ticket?page=" + this.pageOption.currentPage + "&pageSize=" + this.pageOption.pageSize + this.searchStr, { loadingClose: true })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.pageData = data.data.pageData.data
            this.pageOption.total = data.data.pageData.total
            this.adminUsers = data.data.adminUsers
            this.ticketNumChange = false
            this.loading = false
          }
        })
    },
    handleRevoke(index, row) {
      this.loading = true
      this.$axios.post("/api/admin/ticket/update", { id: this.pageData[index].id, sign_status: "已撤销" }, { loadingClose: true })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.pageData[index].sign_status = "已撤销"
            this.$message.success(data.msg)
            this.loading = false
          } else {
            this.loading = false
            this.$message.error(data.msg)
          }
        });
    },
    handleSearch (search) {
      if (this.ticketNumChange) return
      this.ticketNumChange = true
      if (false === search) {
        this.resetCurrentPage()
        return
      }

      this.timeoutId = setTimeout(() => {
        this.resetCurrentPage()
      }, 500)
    },
    resetCurrentPage () {
      if (this.pageOption.currentPage === 1) {
        this.fetchData()
        return
      }
      this.pageOption.currentPage = 1
    }
  },
  provide () {
    return {
      pageOption: this.pageOption
    }
  },
  beforeDestroy () {
    if (this.timeoutId) clearTimeout(this.timeoutId)
  },
  mounted () {
    this.fetchData()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ticket_manage/TicketManagePage.vue